import clsx from 'clsx';
import { Children, cloneElement, FC, ReactNode } from 'react';
import * as ReactIs from 'react-is';
import { overrideTailwindClasses } from 'tailwind-override';

interface Props {
  className?: string;
  children: ReactNode;
}

export const ScrollableCardGrid: FC<Props> = ({ children, className }) => (
  <div
    className={overrideTailwindClasses(
      clsx(
        'flex px-6 -mx-6 overflow-x-scroll laptop:gap-x-6 laptop:px-0 laptop:-mx-0 laptop:overflow-x-visible snap-x scrollbar-hide laptop:grid laptop:grid-cols-3 laptop:gap-y-12',
        className
      )
    )}
  >
    {Children.map(children, (child) => {
      const scrollableClassName =
        'w-11/12 max-w-[360px] laptop:max-w-[unset] shrink-0 laptop:w-full snap-start scroll-m-6 mr-6 last:m-0';
      if (ReactIs.isElement(child)) {
        const props = child.props as Record<string, unknown>;
        const childClassName = props.className as string | undefined;
        return cloneElement(child, {
          className: overrideTailwindClasses(
            clsx(scrollableClassName, childClassName)
          ),
        });
      }
      return (
        <div
          className={overrideTailwindClasses(
            clsx('h-full', scrollableClassName)
          )}
        >
          {child}
        </div>
      );
    })}
  </div>
);
